import React from 'react';
import { SelectOption } from '../../types';

type SelectProps = {
  options: SelectOption[];
  id?: string;
  name?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
};

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ options, id, name, placeholder, onChange }, ref) => {
    return (
      <div className="select">
        <select ref={ref} id={id} name={name} onChange={onChange ? e => onChange(e.target.value) : undefined}>
          {placeholder && <option value="">{placeholder}</option>}
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  },
);
